{
    "CX_Record_Licences_None": "None",
    "CX_Record_Licences_CXRRecord": "CXR Record",
    "CX_Record_Licences_CXRUser": "CXR User",
    "CX_Record_Licences_CXRManager": "CXR Manager",
    "CX_Record_Device_Or_Agent_Error": "An agent or device is required for a {} subscription",
    "NAME": "CXRecordLanguage"
}
